export { WidgetQuickShare } from "./WidgetQuickShare";
